<template>
	<div class="halloween-loader">
		<svg class="halloween-loader-image" xmlns="http://www.w3.org/2000/svg"  width="68" height="80" viewBox="0 0 68 80">
			<path fill-rule="evenodd" fill="none" d="M-38-19h144v144H-38z"/>
			<path fill="#FFF" fill-rule="nonzero" d="M0 79.26V20.572L21.6 0h24.8L68 20.571v58.69L56 68.35l-11 10-11-10-11 10-11-10-12 10.91zM2 21.43v53.31l10-9.09 11 10 11-10 11 10 11-10 10 9.09V21.43L45.6 2H22.4L2 21.429zM50 42v4.414L39.414 57H28.586L18 46.414V42h32zm-30 3.586L29.414 55h9.172L48 45.586V44H20v1.586zM43 27h12v2H43v-2zm-30 0h12v2H13v-2z"/>
		</svg>
		<div class="halloween-loader-track"></div>
	</div>
</template>

<script>
export default {
	name: "halloween-loader"
};
</script>

<style scoped lang="scss">
@keyframes theme-halloween-loader-image {
	from {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-8px);
	}
	to {
		transform: translateY(0);
	}
}
@keyframes theme-halloween-loader-thumb {
	from {
		transform: translateX(-21px);
	}
	50% {
		transform: translateX(54px);
	}
	to {
		transform: translateX(-21px);
	}
}

.halloween-loader {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
.halloween-loader-image {
	margin-bottom: 26px;
	animation: theme-halloween-loader-image 2.8s ease-in-out infinite;
}
.halloween-loader-track {
	display: block;
	width: 66px;
	height: 2px;
	position: relative;
	background-color: rgba(255, 255, 255, 0.1);
	overflow: hidden;
}
.halloween-loader-track::after {
	content: "";
	height: 2px;
	width: 33px;
	position: absolute;
	left: 0;
	top: 0;
	background-color: white;
	animation: theme-halloween-loader-thumb 2.8s ease-in-out infinite;
}
</style>
